module.exports = __webpack_public_path__ + "static/media/search.16bc30b8.svg";